import { render, staticRenderFns } from "./ViewApnZone.vue?vue&type=template&id=5c804e23&scoped=true"
import script from "./ViewApnZone.vue?vue&type=script&lang=js"
export * from "./ViewApnZone.vue?vue&type=script&lang=js"
import style0 from "./ViewApnZone.vue?vue&type=style&index=0&id=5c804e23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c804e23",
  null
  
)

export default component.exports